export function groupMapper(group) {
  group.avatarBg = getProfileClassNameFromUUID(group.id);
  group.avatarImage = group.images?.medium?.url;
  return group;
}
